// extracted by mini-css-extract-plugin
export default {"container":"App_container__H+w8i","body":"App_body__bGoFO","content":"App_content__m4fq0"};